<template>
  <div>
    <base-card v-if="item == 7">
      <v-card-text>
        <v-card-text>
          <div class="mb-5"><span class="text-h6">Restaurant Table</span></div>
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" lg="3"
              ><v-text-field
                class="mt-n5"
                v-model="searchBranch"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field
            ></v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="branchList"
            :search="searchBranch"
            @click:row="handleClick"
          >
          </v-data-table>
        </v-card-text>
      </v-card-text>
    </base-card>
    <v-dialog v-model="dialog" width="800">
      <base-card>
        <v-card-text>
          <div class="mb-5">
            <span class="text-h6">{{ branchName }}'s Table</span>
          </div>

          <v-row align="center" dense>
            <!-- LEFT: ACTION BUTTONS -->
            <v-col cols="12" md="8" class="d-flex flex-wrap align-center">
              <v-btn
                class="mr-2 mb-2"
                small
                color="primary"
                dark
                @click="(title = 'Add'), openDialog()"
              >
                Add Table
              </v-btn>

              <v-btn
                class="mr-2 mb-2"
                small
                color="primary"
                dark
                @click="(title = 'Add'), openBulkDialog()"
              >
                Add Bulk Table
              </v-btn>

              <v-btn
                class="mb-2"
                small
                outlined
                color="primary"
                dark
                @click="printContent"
              >
                Print Table QR Code
              </v-btn>
            </v-col>

            <!-- RIGHT: SEARCH -->
            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                hide-details
                dense
                outlined
              />
            </v-col>
          </v-row>
          <v-data-table
            v-model="selected"
            :headers="tableHeader"
            :items="tableList"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            item-key="table_id"
            @page-count="pageCount = $event"
            :search="search"
            hide-default-footer
            @click:row="handleEditTable"
            show-select
          >
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>
        </v-card-text>
      </base-card>
    </v-dialog>

    <v-dialog v-model="dialogTable" width="400">
      <base-card>
        <v-card-text class="mt-3">
          <div class="mb-5">
            <span class="text-h6">{{ title }} Table</span>
          </div>
          <v-text-field
            prepend-icon="mdi-table-furniture"
            label="Table number"
            v-model="tNumber"
            :error-messages="tNumberErrors"
            required
            @input="$v.tNumber.$touch()"
            @blur="$v.tNumber.$touch()"
          ></v-text-field>

          <v-select
            prepend-icon="mdi-seat"
            v-model="tSeats"
            :items="tSelection"
            label="Seats"
            :error-messages="tSeatsErrors"
            required
            @input="$v.tSeats.$touch()"
            @blur="$v.tSeats.$touch()"
          ></v-select>

          <!-- <v-text-field
            prepend-icon="mdi-seat"
            label="Seats"
            v-model="tSeats"
            type="number"
            :error-messages="tSeatsErrors"
            required
            @input="$v.tSeats.$touch()"
            @blur="$v.tSeats.$touch()"
          ></v-text-field> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            v-if="title == 'Edit'"
            @click="dialogDelete = true"
            text
            icon
            color="red lighten-2"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogAction" text> save </v-btn>
        </v-card-actions>
      </base-card>
    </v-dialog>

    <v-dialog v-model="dialogBulkTable" max-width="600">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium">
          Add Bulk Tables
        </v-card-title>

        <v-card-text>
          <!-- RANGE INPUT -->
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model.number="startTable"
                label="Start Table No."
                type="number"
                min="1"
                outlined
                dense
              />
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model.number="endTable"
                label="End Table No."
                type="number"
                :min="startTable"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <!-- SEAT PRESET -->
          <v-select
            v-model="seatCount"
            :items="tSelection"
            label="Seats per table"
            outlined
            dense
          />

          <v-select
            v-model="nameFormat"
            :items="nameFormatOptions"
            label="Table naming format"
            outlined
            dense
            class="mt-3"
          />

          <!-- INFO / VALIDATION -->
          <v-alert v-if="tableCount > 50" type="error" dense text class="mt-2">
            Maximum 50 tables can be generated at one time
          </v-alert>

          <v-alert
            v-else-if="tableCount > 0"
            type="info"
            dense
            text
            class="mt-2"
          >
            You are about to create <strong>{{ tableCount }}</strong> tables
          </v-alert>

          <!-- PREVIEW -->
          <v-simple-table dense class="mt-4">
            <thead>
              <tr>
                <th>Table Number</th>
                <th>Seats</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="table in previewTables" :key="table.table_no">
                <td>{{ table.table_name }}</td>
                <td>{{ table.seats }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="resetBulkTable"> Cancel </v-btn>
          <v-btn
            color="primary"
            :disabled="!canGenerate"
            @click="generateTables"
          >
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card>
        <v-card-title class="text-subtitle-1"
          >Are you sure you want to delete this item?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" @click="deleteTable()" text>OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-show="false" id="printable-content">
      <div
        style="
          display: grid;
          grid-template-columns: auto auto;
          grid-auto-rows: 450px;
          grid-gap: 10px;
        "
      >
        <div v-for="item in selected" :key="item.table_url">
          <div
            style="
              text-align: center;
              padding: 20px 0;
              font-size: 18px;
              height: auto;
            "
          >
            <vue-qr
              style="border: 3px solid grey"
              :text="QRlink + item.table_url"
              :logoSrc="logo"
              logoBackgroundColor="#00000000"
              :size="250"
            ></vue-qr>
            <br />
            <br />
            <span style="font-weight: bold; font-size: 24px"
              >Table No: {{ item.number }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import { BASEURL, BASESYNCURL } from "@/api/baseurl";
import axios from "axios";
import { validationMixin } from "vuelidate";
import {
  required,
  minValue,
  numeric,
  alphaNum,
  sameAs,
  not,
} from "vuelidate/lib/validators";
import VueQr from "vue-qr";

export default {
  props: {
    item: {
      type: Number,
      default: "",
    },
  },
  mixins: [validationMixin],
  components: { VueQr },
  validations: {
    tNumber: { required, sameAs: not(sameAs("zero")), alphaNum },
    tSeats: { required, minValue: minValue(1), numeric },
  },

  data: () => ({
    domain: BASEURL,
    syncDomain: BASESYNCURL,
    snackbar: false,
    text: "",
    snackbarColor: "",
    timeout: 1900,
    companyID: "",
    branchList: [],
    tableList: [],
    selected: [],
    title: "",
    dialog: false,
    search: "",
    searchBranch: "",
    dialogTable: false,
    tNumber: "",
    tSeats: 4,
    tSelection: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    branchURL: "",
    logo: "https://api.optimy.com.my/asset/logo.png",
    page: 1,
    pageCount: 0,
    zero: "0",
    itemsPerPage: 10,
    dialogQR: false,
    dialogDelete: false,

    ////////
    dialogBulkTable: false,
    startTable: 1,
    endTable: 20,
    seatCount: 4,
    nameFormat: "number",
    nameFormatOptions: [
      { text: "1, 2, 3", value: "number" },
      { text: "T1, T2, T3", value: "T-number" },
      { text: "T01, T02, T03", value: "T-2digit" },
      { text: "Table-1, Table-2", value: "Table-number" },
    ],
    ////////

    branchID: "",
    branchName: "",
    selectTable: "",
    headers: [
      {
        text: "Branch",
        align: "start",
        value: "name",
        sortable: false,
      },
      {
        text: "Total table",
        align: "center",
        value: "numberTable",
        sortable: false,
      },
    ],
    tableHeader: [
      {
        text: "Table number#",
        align: "start",
        value: "number",
        sortable: false,
      },
      {
        text: "Seats",
        align: "start",
        value: "seats",
        sortable: false,
      },
    ],
  }),
  computed: {
    QRlink() {
      // ----production----
      var link = "https://qr.optimy.com.my/" + this.branchURL + "/";
      // ----testing----
      // var link = "https://pos-qr.lkmng.com/" + this.branchURL + "/";
      return link;
    },
    tNumberErrors() {
      const errors = [];
      if (!this.$v.tNumber.$dirty) return errors;
      !this.$v.tNumber.required && errors.push("Table Number is required");
      !this.$v.tNumber.alphaNum &&
        errors.push("Table number cannot be negative");
      !this.$v.tNumber.sameAs && errors.push("Table number cannot be 0");
      return errors;
    },

    tSeatsErrors() {
      const errors = [];
      if (!this.$v.tSeats.$dirty) return errors;
      !this.$v.tSeats.minValue && errors.push("Must be positive and not 0");
      !this.$v.tSeats.required && errors.push("Seats is required");
      !this.$v.tSeats.numeric && errors.push("Seats must be integer");
      return errors;
    },

    tableCount() {
      if (!this.startTable || !this.endTable) return 0;
      return this.endTable - this.startTable + 1;
    },

    canGenerate() {
      return (
        this.tableCount > 0 &&
        this.tableCount <= 50 &&
        this.startTable > 0 &&
        this.endTable >= this.startTable
      );
    },

    previewTables() {
      if (!this.canGenerate) return [];

      const tables = [];
      for (let i = this.startTable; i <= this.endTable; i++) {
        tables.push({
          table_no: i,
          table_name: this.formatTableName(i),
          seats: this.seatCount,
        });
      }
      return tables;
    },
  },

  created() {
    var CryptoJS = require("crypto-js");
    var x = localStorage.getItem("userInfo");
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(x, "secret key 123");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.companyID = decryptedData.company_id;
    this.getBranchAndTableNum();
  },
  methods: {
    resetBulkTable() {
      this.dialogBulkTable = false;
      this.startTable = 1;
      this.endTable = 20;
      this.seatCount = 4;
      this.nameFormat = "number";
    },

    formatTableName(no) {
      switch (this.nameFormat) {
        case "T-number":
          return `T${no}`;

        case "T-2digit":
          return `T${String(no).padStart(2, "0")}`;

        case "Table-number":
          return `Table-${no}`;

        default:
          return String(no);
      }
    },
    generateTables() {
      const payload = this.previewTables;
      const params = new URLSearchParams();
      params.append("generateBulkTables", "done");
      params.append("branch_id", this.branchID);
      params.append("table_list", JSON.stringify(payload));

      axios({
        method: "post",
        url: this.domain + "/table/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          const { status, created, skipped, total } = response.data;

          // Refresh only if something was created
          if (created > 0) {
            this.getAllTable();
            this.getBranchAndTableNum();
            this.sendNotication(this.branchID);
          }
          if (status === "1") {
            // All success
            this.resetBulkTable();
            this.text = `Successfully created ${created} tables`;
            this.snackbarColor = "success";
          } else if (status === "3") {
            // Partial success – some exist
            this.resetBulkTable();
            this.text = `Created ${created} tables. ${skipped} tables already exist.`;
            this.snackbarColor = "warning";
          } else if (status === "2") {
            // Partial success – some failed
            this.text = `Created ${created} out of ${total} tables.`;
            this.snackbarColor = "warning";
          } else {
            // status === "4" or unexpected
            this.text = "No tables were created. All tables may already exist.";
            this.snackbarColor = "error";
          }

          this.snackbar = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    printContent() {
      const printableContent = document.getElementById("printable-content");
      const printWindow = window.open("", "", "height=1000,width=1000");
      printWindow.document.write(printableContent.innerHTML);
      printWindow.print();
    },
    getBranchAndTableNum() {
      const params = new URLSearchParams();
      params.append("getBranchAndTableNum", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/table/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.branchList = response.data.table;
          } else {
            console.log("no list get");
            this.branchList = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAllTable() {
      const params = new URLSearchParams();
      params.append("getAllTable", "done");
      params.append("branch_id", this.branchID);
      axios({
        method: "post",
        url: this.domain + "/table/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.tableList = response.data.table;
            this.selected = this.tableList;
          } else {
            console.log("no list get");
            this.tableList = [];
            this.selected = this.tableList;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    handleClick(item) {
      this.branchName = item.name;
      this.branchID = item.branch_id;
      this.branchURL = item.branch_url;

      this.dialog = true;
      this.getAllTable();
    },

    handleEditTable(item) {
      this.tNumber = item.number;
      this.tSeats = parseInt(item.seats);
      this.selectTable = item.table_id;
      this.title = "Edit";
      this.openDialog();
    },

    openBulkDialog() {
      this.dialogBulkTable = true;
    },

    openDialog() {
      if (this.title == "Add") {
        this.$v.$reset();
        this.tNumber = "";
        this.tSeats = 4;
        this.dialogTable = true;
      } else {
        this.$v.$reset();
        this.dialogTable = true;
      }
    },

    openDialogQR() {
      this.dialogQR = true;
    },

    sendNotication(branch_id) {
      const params = new URLSearchParams();
      params.append("send_notification", "done");
      params.append("branch_id", branch_id);
      params.append("type", "1");

      axios({
        method: "post",
        url: this.syncDomain + "/sync/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            console.log("Send Notification successfully");
          } else {
            console.log("Send Notification fail");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteTable() {
      const params = new URLSearchParams();
      params.append("delete", "done");
      params.append("table_id", this.selectTable);
      axios({
        method: "post",
        url: this.domain + "/table/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.dialogTable = false;
            this.text = "Successfully delete";
            this.snackbar = true;
            this.snackbarColor = "success";
            this.dialogDelete = false;
            this.getAllTable();
            this.getBranchAndTableNum();
            this.sendNotication(this.branchID);
          } else {
            this.text = "Please try again later";
            this.snackbar = true;
            this.snackbarColor = "error";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    dialogAction() {
      if (this.title == "Add") {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const params = new URLSearchParams();
          params.append("addTable", "done");
          params.append("branch_id", this.branchID);
          params.append("number", this.tNumber);
          params.append("seats", this.tSeats);

          axios({
            method: "post",
            url: this.domain + "/table/index.php",
            data: params,
          })
            .then((response) => {
              console.log(response);
              if (response.data.status == "1") {
                this.dialogTable = false;
                this.text = "Successfully add";
                this.snackbar = true;
                this.snackbarColor = "success";
                this.getAllTable();
                this.getBranchAndTableNum();
                this.sendNotication(this.branchID);
              } else if (response.data.status == "3") {
                this.text = "Please use another table number";
                this.snackbar = true;
                this.snackbarColor = "error";
              } else {
                this.text = "Please try again later";
                this.snackbar = true;
                this.snackbarColor = "error";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } else {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const params = new URLSearchParams();
          params.append("editTable", "done");
          params.append("table_id", this.selectTable);
          params.append("branch_id", this.branchID);
          params.append("number", this.tNumber);
          params.append("seats", this.tSeats);
          axios({
            method: "post",
            url: this.domain + "/table/index.php",
            data: params,
          })
            .then((response) => {
              console.log(response);
              if (response.data.status == "1") {
                this.dialogTable = false;
                this.text = "Successfully edit";
                this.snackbar = true;
                this.snackbarColor = "success";
                this.getAllTable();
                this.getBranchAndTableNum();
                this.sendNotication(this.branchID);
              } else if (response.data.status == "3") {
                this.text = "Please use another table number";
                this.snackbar = true;
                this.snackbarColor = "error";
              } else {
                this.text = "Please try again later";
                this.snackbar = true;
                this.snackbarColor = "error";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    },
  },
};
</script>
<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Adjust the number of columns here */
  grid-gap: 10px; /* Adjust the gap between grid items */
}

.grid-item {
  background-color: #ccc;
  padding: 20px;
  text-align: center;
}
</style>